export default __webpack_public_path__ + "static/media/qa.40687d3e.svg";